import React from "react";

const RefundPolicyModal = ({ isOpen, onClose, mobile }) => {
  if (!isOpen) return null;

  const sections = [
    {
      title: "1. Finality of Payment",
      content:
        "All payments made to aiComposz are final. Once a transaction is processed and image credits are added to your account, the purchase is considered complete and non-reversible.",
    },
    {
      title: "2. No Refund Policy",
      content:
        "There are absolutely no refunds once a payment is made. This policy applies to all circumstances, including but not limited to: dissatisfaction with AI-generated results, technical errors on the user's end, accidental purchases, or changes in personal requirements.",
    },
    {
      title: "3. Service & AI Limitations",
      content:
        "As stated in our Terms, AI models may produce unexpected or flawed results. No refunds will be issued based on the artistic or technical quality of the generated images. Furthermore, model unavailability or temporary service interruptions do not entitle users to a refund.",
    },
    {
      title: "4. Exceptional Circumstances",
      content:
        "In extremely rare and exceptional circumstances, users may submit a written request for a refund to 'team@aicomposz.com'. Any such request will be reviewed at our sole and absolute discretion. The submission of a request does not in any way guarantee that a refund will be granted.",
    },
    {
      title: "5. Credit Deduction Acknowledgement",
      content:
        "By initiating an image generation, you acknowledge that credits will be deducted immediately. If the generation fails to reach you due to a lost internet connection, page refresh, or closure of the application, no refund or credit reinstatement will be provided.",
    },
  ];

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-2xl md:max-h-[80vh] md:rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-2xl md:max-h-[80vh] rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        // style={{ padding: mobile ? "1rem" : "3rem" }}
      >
        <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <h2 className="text-xl font-bold text-white tracking-tight">Refund Policy</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="md:h-6 w-6 text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto mt-10 md:p-8 space-y-6 text-sm text-slate-300 leading-relaxed">
          {sections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h3 className="text-indigo-400 font-bold text-base">{section.title}</h3>
              <p>{section.content}</p>
            </div>
          ))}
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyModal;
